import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerFooter,
  DrawerClose,
} from "@/components/ui/drawer";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Button } from "@/components/ui/button";

const RUNNING_LATE_REASONS = ["Traffic", "Construction", "Previous lesson ran long", "Weather", "Railroad crossing", "Vehicle issue", "Other"];
const RUNNING_LATE_DELAYS = [
  { value: "5", label: "5 min" },
  { value: "10", label: "10 min" },
  { value: "15", label: "15 min" },
  { value: "20", label: "20 min" },
  { value: "30", label: "30+ min" },
];

// Instructor Dashboard -> "Running Late" 2-step drawer. Extracted from
// InstructorDashboard.js (props-driven, no behavior change).
export const RunningLateDrawer = ({
  open,
  onOpenChange,
  step,
  reason,
  onReasonChange,
  delay,
  onDelayChange,
  onBack,
  onNext,
  onSend,
  sending,
}) => (
  <Drawer open={open} onOpenChange={onOpenChange}>
    <DrawerContent data-testid="running-late-drawer">
      <DrawerHeader>
        <DrawerTitle>{step === 1 ? "Why are you running late?" : "How late will you be?"}</DrawerTitle>
      </DrawerHeader>
      <div className="px-4 pb-4">
        {step === 1 ? (
          <ToggleGroup
            type="single"
            value={reason}
            onValueChange={(v) => v && onReasonChange(v)}
            className="flex-wrap justify-start gap-2"
            data-testid="running-late-reason-step"
          >
            {RUNNING_LATE_REASONS.map((r) => (
              <ToggleGroupItem key={r} value={r} className="min-h-11 px-3 rounded-lg border bg-card data-[state=on]:bg-[hsl(var(--role-accent))] data-[state=on]:text-white" data-testid={`running-late-reason-${r.toLowerCase().replace(/\s+/g, "-")}`}>
                {r}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        ) : (
          <ToggleGroup
            type="single"
            value={delay}
            onValueChange={(v) => v && onDelayChange(v)}
            className="flex-wrap justify-start gap-2"
            data-testid="running-late-delay-step"
          >
            {RUNNING_LATE_DELAYS.map((d) => (
              <ToggleGroupItem key={d.value} value={d.value} className="min-h-11 px-4 rounded-lg border bg-card data-[state=on]:bg-[hsl(var(--role-accent))] data-[state=on]:text-white" data-testid={`running-late-delay-${d.value}`}>
                {d.label}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        )}
      </div>
      <DrawerFooter className="flex-row gap-2">
        {step === 2 && (
          <Button variant="outline" onClick={onBack} data-testid="running-late-back-button">Back</Button>
        )}
        {step === 1 ? (
          <Button className="flex-1 bg-[hsl(var(--role-accent))] hover:opacity-95" disabled={!reason} onClick={onNext} data-testid="running-late-next-button">
            Next
          </Button>
        ) : (
          <Button className="flex-1 bg-[hsl(var(--role-accent))] hover:opacity-95" disabled={!delay || sending} onClick={onSend} data-testid="running-late-send-button">
            Send update
          </Button>
        )}
        <DrawerClose asChild>
          <Button variant="ghost" data-testid="running-late-cancel-button">Cancel</Button>
        </DrawerClose>
      </DrawerFooter>
    </DrawerContent>
  </Drawer>
);
